import { render, staticRenderFns } from "./DealSheetDetails.vue?vue&type=template&id=0134c970&scoped=true"
import script from "./DealSheetDetails.vue?vue&type=script&lang=js"
export * from "./DealSheetDetails.vue?vue&type=script&lang=js"
import style0 from "./DealSheetDetails.vue?vue&type=style&index=0&id=0134c970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134c970",
  null
  
)

export default component.exports